import type { ChatMessage } from "../hooks/useChat";
import { v4 as uuidv4 } from "uuid";

/**
 * Creates a bot response message object
 */
export function createChatbotResponse(
  text: string,
  metadata?: Record<string, any>
): Omit<ChatMessage, "id" | "timestamp"> {
  return {
    text,
    type: "bot",
    metadata,
  };
}

/**
 * Formats a timestamp according to the provided format
 */
export function formatTimestamp(
  timestamp: number,
  format: string = "HH:mm"
): string {
  const date = new Date(timestamp);

  if (format === "HH:mm") {
    return `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}`;
  }

  if (format === "HH:mm:ss") {
    return `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
  }

  return date.toLocaleString();
}

export const processResponse = async (
  response: string | ((message: string) => string | Promise<string>),
  messageText: string
): Promise<string> => {
  if (typeof response === "function") {
    const result = response(messageText);
    if (result instanceof Promise) {
      return await result;
    }
    return result;
  }
  return response;
};
